export default __webpack_public_path__ + "static/media/piggy-bank-and-coins.dbff48d4.svg";